import './event-listing-filters.html.twig';
import './event-listing-filters.scss';

const filters = {
  country: null, // string
  region: null, // string
  search: null, // string
  type: null, // string
  format: [], // string[]
  dateTo: null, // string e.g 2022-10-15
  dateFrom: null, // string e.g 2022-10-15
  orderBy: null, // string
  latitude: null, // string e.g 78.6534192
  longitude: null, // string e.g 78.6534192
};

function initializeFilters() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const entries = urlSearchParams.entries();

  // Url params are kebab case, filters are camel case
  const camelCase = (kebabCase) => {
    const regex = /-(.)/g;
    return kebabCase.replaceAll(regex, (match, p1) => p1.toUpperCase());
  };

  Array.from(entries).forEach(([key, value]) => {
    if (key === 'format') {
      filters[camelCase(key)] = value.split(',');
    } else {
      filters[camelCase(key)] = value;
    }
  });
}

function clearFormatFilter(value) {
  filters.format = filters.format.filter((format) => {
    if (format != value) return format;
  });
}

function clearAllFilters() {
  filters.country = null;
  filters.region = null;
  filters.search = null;
  filters.type = null;
  filters.format = [];
  filters.dateTo = null;
  filters.dateFrom = null;
}

function clearFilter(type, value) {
  switch (type) {
    case 'country':
      filters.country = null;
      filters.region = null;
      return;
    case 'region':
      filters.region = null;
      return;
    case 'search':
      filters.search = null;
      return;
    case 'type':
      filters.type = null;
      return;
    case 'format':
      clearFormatFilter(value);
      return;
    case 'date-to':
      filters.dateTo = null;
      return;

    case 'date-from':
      filters.dateFrom = null;
      return;

    case 'orderBy':
      filters.orderBy = null;
      return;

    case 'latitude':
      filters.latitude = null;
      return;

    case 'longitude':
      filters.longitude = null;
      return;
  }
}

function updatePageFilters() {
  const filterParams = `${filters.country != null ? `&country=${filters.country}` : ''}${
    filters.region != null ? `&region=${filters.region}` : ''
  }${filters.type != null ? `&type=${filters.type}` : ''}${filters.search != null ? `&search=${filters.search}` : ''}${
    filters.format != null && filters.format !== [] ? `&format=${filters.format.join(',')}` : ''
  }${filters.dateFrom != null ? `&date-from=${filters.dateFrom}` : ''}${
    filters.dateTo != null ? `&date-to=${filters.dateTo}` : ''
  }${filters.orderBy != null ? `&order-by=${filters.orderBy}` : ''}${
    filters.latitude != null ? `&latitude=${filters.latitude}` : ''
  }${filters.longitude != null ? `&longitude=${filters.longitude}` : ''}`;

  if (filterParams.length > 0) {
    window.location.href = window.location.origin + window.location.pathname + filterParams.replace('&', '?');
    return;
  }

  window.location.href = window.location.origin + window.location.pathname;
}

export default function () {
  const el = document.querySelector('.event-listing-filters');
  if (el) {
    initializeFilters();

    const activeFilters = el.querySelectorAll('.event-listing-filters__filter');
    activeFilters.forEach((activeFilter) => {
      activeFilter.addEventListener('click', () => {
        const type = activeFilter.getAttribute('data-filter-type');
        const value = activeFilter.getAttribute('data-filter-name');
        if (type) {
          clearFilter(type, value);
          updatePageFilters();
        }
      });
    });

    const removeAllLink = el.querySelector('.event-listing-filters__remove-all-link');
    if (removeAllLink) {
      removeAllLink.addEventListener('click', () => {
        clearAllFilters();
        updatePageFilters();
      });
    }

    const dropdown = el.querySelector('.event-listing-filters__dropdown');
    if (dropdown) {
      const dropdownList = dropdown.querySelector('.event-listing-filters__dropdown-list');
      const dropdownSelected = dropdown.querySelector('.event-listing-filters__dropdown-selected');
      if (dropdownList) {
        dropdown.addEventListener('click', () => {
          dropdownList.classList.toggle('event-listing-filters__dropdown-list--hidden');
        });
        dropdown.addEventListener('keydown', (e) => {
          if (e.keyCode === 13) {
            dropdown.click();
          }
        });
        const dropdownOptions = dropdownList.querySelectorAll('.event-listing-filters__dropdown-option');
        if (dropdownOptions) {
          dropdownOptions.forEach((dropdownOption) => {
            dropdownOption.addEventListener('click', () => {
              if (!dropdownOption.classList.contains('disabled')) {
                let currentSelectedValue = dropdownSelected.innerText;
                dropdownSelected.innerText = dropdownOption.innerText;
                dropdownOption.innerText = currentSelectedValue;
                filters.orderBy = dropdownOption.getAttribute('data-filter-option');
                if (dropdownOption.getAttribute('data-filter-option') === 'location') {
                  filters.type = 'in-person';
                }
                dropdownOption.setAttribute('data-filter-option', currentSelectedValue.toLowerCase());
                updatePageFilters();
              }
            });
            dropdownOption.addEventListener('keydown', (e) => {
              if (e.keyCode === 13) {
                dropdownOption.click();
              }
            });
          });
        }
      }

      // --- Geolocation feature
      // --- References used:
      // --- https://web.dev/native-hardware-user-location/
      // --- https://stackoverflow.com/questions/10077606/check-if-geolocation-was-allowed-and-get-lat-lon
      // -----------------------

      // Disables the Location option in the dropdown
      const locationDisabled = () => {
        // First check if the location isn't currently selected
        // If it is, we'll reset to Relevance (doesn't change the URL though)
        const locationLabel = 'Location';
        if (dropdownSelected.innerText === locationLabel) {
          let relevanceOption = dropdownList.querySelector(
            '.event-listing-filters__dropdown-option[data-filter-option=relevance]'
          );
          if (relevanceOption) {
            dropdownSelected.innerText = relevanceOption.innerText;
            relevanceOption.innerText = locationLabel;
            relevanceOption.setAttribute('data-filter-option', locationLabel.toLowerCase());
          }
        }
        // Disable the Location option on the dropdown
        let locationOption = dropdownList.querySelector(
          '.event-listing-filters__dropdown-option[data-filter-option=location]'
        );
        if (locationOption) {
          locationOption.classList.add('disabled');
          locationOption.innerText = 'Geolocation disabled';
        }
      };

      // Browser doesn't support geolocation API
      if (!navigator.geolocation) {
        locationDisabled();
        return;
      }

      // Check if latitude and longitude are already in the query string
      var searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('latitude') != null && searchParams.get('longitude') != null) {
        return;
      }

      var geoOptions = {
        maximumAge: 5 * 60 * 1000, // rough estimate, use a recently obtained geolocation result
        timeout: 10 * 1000, // ensures the coord function times out
      };
      var checkCoordsInterval;

      // Function for the setInterval in case permissions were "blocked"
      // and were changed to "granted"
      // Checks if permission is granted and retrieves the coordinates
      const getCoordsInterval = () => {
        return new Promise((resolve, reject) =>
          navigator.permissions
            ? // Permission API is implemented
              navigator.permissions
                .query({
                  name: 'geolocation',
                })
                .then((permission) => {
                  // is geolocation granted?
                  if (permission.state === 'granted') {
                    // We don't need the interval anymore
                    clearInterval(checkCoordsInterval);
                    // Returning geolocation data
                    return navigator.geolocation.getCurrentPosition(geoSuccess, locationDisabled, geoOptions);
                  } else {
                    resolve(null);
                  }
                })
            : // Permission API was not implemented
              reject(new Error('Permission API is not supported'))
        );
      };

      const geoSuccess = (position, forceOrderByLocation = false) => {
        filters.latitude = position.coords.latitude;
        filters.longitude = position.coords.longitude;

        if (forceOrderByLocation) {
          filters.orderBy = 'location';
        }
        updatePageFilters();
      };
      const geoError = (error) => {
        locationDisabled();
        // error.code can be:
        //   0: unknown error
        //   1: permission denied
        //   2: position unavailable (error response from location provider)
        //   3: timed out
        if (error.code == 1) {
          // add a recurring function to check if the permission is updated
          checkCoordsInterval = setInterval(getCoordsInterval, 1000);
        }

        // Make geolocation component visible.
        const alert = document.querySelector('.event-listing-hero__alert');
        if (alert) {
          alert.classList.add('active');
          alert.querySelector('.event-listing-hero__alert-close').addEventListener('click', () => alert.remove());
        }

      };

      // If the initial request for geolocation information is accepted, then
      // we force to order by location.
      // The initial request requires a clear interaction from the user, so there is a clear intent to want to use geolocation for sorting
      const initialGeoSuccess = (position) => geoSuccess(position, true);
      navigator.geolocation.getCurrentPosition(initialGeoSuccess, geoError, geoOptions);
    }
  }
}
